export default class Helpers {
  static getTranslateX(matrix) {
    const values = matrix.match(/matrix.*\((.+)\)/)[1].split(', ');
    return parseFloat(values[4]);
  }
}
